export enum LogEventType {
  ALL = 1,
  OPERATOR_LOGIN = 2,
  OPERATOR_LOGOUT = 8,
  ADMIN_LOGIN = 16,
  ADMIN_LOGOUT = 32
}
